import NewFooter from '../../src/components/HomePage/NewFooter';
import {
  RefundContainer,
  RefundContent,
  Title,
} from '../../src/components/PrivacyPolicy/Refund/styled';
import GlobalStyle from '../../src/styles/globalStylesV2';
import NewHeader from '../../src/components/HomePage/NewHeader';
import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import { NextSeo } from 'next-seo';
import { partnerWithUsMetaData } from '../../src/Constants/MetaData';

export default function Index() {
  return (
    <>
      <GlobalStyle />
      <NewHeader nostrip={true} />
      <NextSeo
        noindex={true}
        nofollow={true}
        title={partnerWithUsMetaData.metaTitle}
        description={partnerWithUsMetaData.metaDescription}
      />
      <HomeWrapper noPadding>
        <RefundContainer>
          <Title partnerWithUs>Partner with us</Title>
          <RefundContent atMylo>
            At Mylo our aim to provide all the support to women who wish to go
            the family way and make their parenting journey easier. In order to
            achieve this, we work in close collaboration with women who are
            trying to conceive, those who are pregnant and moms. We continually
            seek feedback from our users via our app and bring together women to
            facilitate peer to peer learning and trust. We innovate to make the
            life of mothers easier by creating various tools and utilities.
          </RefundContent>
          <RefundContent>We invite brands to partner with us!</RefundContent>
          <RefundContent weAreLooking>
            We are looking for partners who complement our expertise and who are
            interested in collaborating with Mylo - to help Indian mothers raise
            happy and healthy families, together.
          </RefundContent>
          <RefundContent>
            Please drop a line at partnerships@mylofamily.com
          </RefundContent>
        </RefundContainer>
      </HomeWrapper>
      <NewFooter></NewFooter>
    </>
  );
}
